import { useDispatch, useSelector } from 'react-redux';

import { TSideEffectState } from '@src/types/common';
import { getIsSignIn } from '@src/store/selectors/session';
import { addEventToCartCall } from '@src/store/actions/cart';
import { getEvent, getEventState } from '@src/store/selectors/event';
import { setModalType } from '@src/store/actions/ui';
import { IEvent, ISortedEventSlot, IEventTicket } from '@src/types/event';
import { sortEventSlots } from '@src/utils/event';
import { MODAL_TYPE_LOGIN } from '@src/const/common';
import * as actions from '@src/store/actions';

interface IUseEventReturn {
	event: IEvent;
	eventState: TSideEffectState;
	sortedEventSlots: ISortedEventSlot[];
	isSignedIn: boolean;
	handleLogin: () => void;
	handleAddToCart: ({ slotId, tickets }: { slotId: string, tickets: IEventTicket[] }) => void;
}

const useEvent = (): IUseEventReturn => {
	const dispatch = useDispatch();
	const event = useSelector(getEvent);
	const { short_link: eventShortLink } = event || {};
	const eventState = useSelector(getEventState);
	const isSignedIn = useSelector(getIsSignIn) as boolean;

	const handleLogin = () => {
		dispatch(setModalType({ type: MODAL_TYPE_LOGIN }));
	};

	const handleAddToCart = ({ slotId, tickets }) => {
		if (isSignedIn) {
			dispatch(addEventToCartCall({ slotId, tickets, event }));
		} else {
			dispatch(actions.addActionsToStash([
				{
					actionMethod: 'addEventToCartCall',
					actionPayload: { slotId, tickets },
				},
				{
					actionMethod: 'historyReplaceCall',
					actionPayload: `/event/${eventShortLink}`,
				},
			]));
			handleLogin();
		}
	};

	return {
		event,
		eventState,
		sortedEventSlots: sortEventSlots(event.slots),
		isSignedIn,
		handleLogin,
		handleAddToCart,
	};
};

export default useEvent;
